import {combine, createEffect, createEvent, createStore, sample} from 'effector';
import {createGate} from 'effector-react';
import api from '../../api/api.js';

export const $usersGroups = createStore([])
export const $userGroupsSelect = combine($usersGroups, groups => {
    return groups.map(group => ({value: group.id, label: (group.nameRu ?? group.name), name: group.name}))
})
export const $userGroupsMap = combine($usersGroups, groups => {
    return Object.fromEntries(groups.map(group => [group.id, (group.nameRu ?? group.name)]))
})
export const $groupsForPerms = combine($usersGroups, groups => {
    return Object.fromEntries(groups.map(group => [group.id, group.name]))
})

export const $usersList = createStore({
    pagination: {totalRecords: 0, totalPages: 0, first: null, last: null, next: '', previous: ''},
    results: []
})

export const $usersTable = createStore({
    limit: 10,
    offset: 0,
    page: 0,
    first: 0
})

export const $selectedUser = createStore(null)

export const AppGate = createGate()
export const UsersGate = createGate()
export const setUsersTableEv = createEvent()
export const selectUserEv = createEvent()
export const resetUserEv = createEvent()
export const submitUserEv = createEvent()

export const getUsersListFx = createEffect()
    .use(async (query) =>  (await api().get(`${SSO_BASE_URL}/api/v1/users/?${query}&ordering=-updated_at`)).data)

export const editUserFx = createEffect()
    .use(async ({id, payload}) =>  (await api().patch(`${SSO_BASE_URL}/api/v1/users/${id}/`, payload)).data)

export const getUsersGroupsFx = createEffect()
    .use(async () =>  (await api().get(`${SSO_BASE_URL}/api/v1/groups/?page={"size":1000, "offset":1}`)).data)

$usersList.on(getUsersListFx.doneData, (state, payload) => payload)
    .reset(UsersGate.close)

$usersTable.on(setUsersTableEv, (state, payload) => ({...state, ...payload}))
    .reset(UsersGate.close)

$selectedUser.on(selectUserEv, (_, user) => user)
    .reset([resetUserEv, editUserFx.doneData])

$usersGroups.on(getUsersGroupsFx.doneData, (state, payload) => payload.results)
    .reset(UsersGate.close)

sample({
    clock: [AppGate.open, UsersGate.open],
    filter: (gate) => !!gate,
    target: getUsersGroupsFx
})

sample({
    source: {table: $usersTable, gate: UsersGate.status},
    clock: [UsersGate.open, $usersTable.updates, editUserFx.doneData],
    filter: ({gate}) => !!gate,
    fn: ({table}) => `page={"size":${table.limit}, "offset":${table.page}}`,
    target: getUsersListFx
})

sample({
    source: $selectedUser,
    clock: submitUserEv,
    fn: (user, ev) => ({id: user.id, payload: ev}),
    target: editUserFx
})